import React from 'react';
import Request from '@its/components/lib/Request';
import PermIdentity from 'material-ui/svg-icons/action/perm-identity';
import header from '../../images/header.png';
import Menu from '../Util/Menu';
import {
  getUser,
  getUserRoles,
} from '../../api';
import {
  setHeader,
  setItems,
} from '@its/components/lib/Container components/DrawerMenuContainer/actions';
import {
  setRoles,
} from '@its/components/lib/Container components/UserContainer/actions';
import {
  isAllowed,
  config,
  developer,
  admin,
} from '@its/components/lib/Container components/UserContainer/roles';

const getDrawerItems = (roles) => {
  const items = [{
    key: 'displaySection',
    text: 'DISPLAYS',
    icon: 'DeviceDvr',
    items: [{
      key: 'displays',
      text: 'LIST',
      icon: 'ActionViewList',
      route: '/displays',
    }, {
      key: 'preview',
      text: 'PREVIEW',
      icon: 'ActionViewModule',
      route: '/displays/preview',
    }],
  }, {
    key: 'departments',
    text: 'DEPARTMENTS',
    icon: 'SocialLocationCity',
    route: '/departments',
  }];
  if (isAllowed([config, developer, admin], roles)) {
    items.push({
      key: 'iterators',
      text: 'TIMERS',
      icon: 'ImageTimer',
      route: '/timers',
    });
  }
  if (isAllowed([developer, admin], roles)) {
    items.push({
      key: 'templates',
      text: 'TEMPLATES',
      icon: 'AvWeb',
      route: '/templates',
    });
  }

  items.push({
    key: 'settings',
    text: 'SETTINGS',
    icon: 'ActionSettings',
    route: '/settings',
  });

  if (isAllowed([developer, admin], roles)) {
    items.push({
      key: 'help',
      text: 'HELP',
      icon: 'ActionHelp',
      route: '/help',
    });
  }
  return items;
};

export default class extends React.Component {

  static propTypes = {
    children: React.PropTypes.any,
  }

  static defaultProps = {
    children: null,
  }

  onSuccess(result, dispatch) {
    const { email, name, surname } = result[0].body;
    dispatch(setRoles(result[1].body));
    dispatch(setHeader({
      username: `${name} ${surname}`,
      email,
      avatar: {
        icon: <PermIdentity />,
      },
      backgroundImage: header,
    }));
    dispatch(setItems(getDrawerItems(result[1].body)));
    return <Menu />;
  }

  render() {
    return (
      <Request request={[getUser, getUserRoles]} onSuccess={this.onSuccess} {...this.props} />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Requests/UserRequest.js
 **/